import { APP_INITIALIZER, ErrorHandler, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { SessionInformationService } from './session-information.service';
import { AppUnitOfWork } from './data/app-unit-of-work';
import { RAFUnitOfWork } from './data/raf-unit-of-work';
// import { PrepareGuard } from './prepare.guard';
// import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { DevExtremeModule } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
// import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { AppInformationService } from './app-information.service';
import { AuthenticationService } from './authentication.service';
import { EntityManagerProvider } from './data/entity-manager-provider';
import { AuthGuard } from './auth.guard';
import { PrepareGuard } from './prepare.guard';
import { JwtInterceptor } from './jwt.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { appInitializer } from './app.initializer';
import { ReportService } from './data/report.service';
import { UtilityService } from './data/utility.service';
import { ToastErrorHandler } from './toast-error-handler.service';

export { AppInformationService, AuthenticationService, SessionInformationService, AppUnitOfWork, AuthGuard, PrepareGuard, RAFUnitOfWork, UtilityService, ReportService };

@NgModule({
    imports: [CommonModule, FormsModule, HttpClientModule],
    providers: [
        { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AuthenticationService] },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: ErrorHandler, useClass: ToastErrorHandler },

    ],
})
export class CoreModule {}
